// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_33s","cls2":"LettersModal-cls2_m8y LettersModal-cls1_33s"};